import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../ui/accordion";

export const Faq = () => {
  const { t } = useLang();
  return (
    <section id="faq" className="relative py-24 sm:py-32 bg-[var(--page)]">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="text-xs uppercase tracking-[0.25em] text-terra font-semibold">{t.faq.overline}</span>
            <h2 className="mt-5 font-display text-[var(--ink)] font-semibold tracking-tight leading-[1.05]
                           text-3xl sm:text-4xl lg:text-5xl">
              {t.faq.title}
            </h2>
            <p className="mt-6 text-base text-[var(--muted-ink)] leading-relaxed max-w-xs">{t.faq.sub}</p>
          </motion.div>
        </div>

        <div className="lg:col-span-8">
          <Accordion type="single" collapsible defaultValue="faq-0" className="w-full">
            {t.faq.items.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
              >
                <AccordionItem value={`faq-${i}`} className="border-b border-[var(--hairline)]">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-display text-lg sm:text-2xl text-[var(--ink)] hover:no-underline py-6"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-answer-${i}`}
                    className="text-base sm:text-lg text-[var(--muted-ink)] leading-relaxed pb-6 max-w-2xl"
                  >
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
